import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from '@admin/layout.component';
import { UsersComponent } from '@admin/pages/users/users.component';
import { EditUserComponent } from '@admin/pages/users/edit-user/edit-user.component';
import { LocationsComponent } from '@admin/pages/locations/locations.component';
import { EditLocationComponent } from '@admin/pages/locations/edit-location/edit-location.component';
import { ProjectsComponent } from '@admin/pages/projects/projects.component';
import { EditProjectComponent } from '@admin/pages/projects/edit-project/edit-project.component';
import { ReleaseNotesComponent } from '@admin/pages/release-notes/release-notes.component';
import { EditReleaseNoteComponent } from '@admin/pages/release-notes/edit-release-notes/edit-release-note.component';
import { CustomerSitesComponent } from '@admin/pages/customer-sites/customer-sites.component';
import { EditCustomerSiteComponent } from '@admin/pages/customer-sites/edit-customer-site/edit-customer-site.component';
import { StatisticsComponent } from '@admin/pages/statistics/statistics.component';
import { WeightChangeCategoriesComponent } from '@admin/pages/weight-change-categories/weight-change-categories.component';

const routes: Routes = [
  {
    path: '',
    component: LayoutComponent,
    children: [
      { path: 'users', component: UsersComponent },
      { path: 'users/:username', component: EditUserComponent },
      { path: 'locations', component: LocationsComponent },
      { path: 'locations/:locationId', component: EditLocationComponent },
      { path: 'projects', component: ProjectsComponent },
      { path: 'projects/:projectId', component: EditProjectComponent },
      { path: 'customer-sites', component: CustomerSitesComponent },
      { path: 'customer-sites/:siteCode', component: EditCustomerSiteComponent },
      { path: 'release-notes', component: ReleaseNotesComponent },
      { path: 'release-notes/:id', component: EditReleaseNoteComponent },
      { path: 'statistics', component: StatisticsComponent },
      { path: 'weight-change-categories', component: WeightChangeCategoriesComponent },
      { path: '**', redirectTo: '/admin/users' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminRoutingModule {}
